import { render, staticRenderFns } from "./VDeleteSalaDialog.vue?vue&type=template&id=691e0e78"
import script from "./VDeleteSalaDialog.vue?vue&type=script&lang=js"
export * from "./VDeleteSalaDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports